module.exports = "/static/img/placeholder2.png?f89f1592c245cee9cdba7c7e9797e43a";